import eventApi from '@/api/event'

// Shared delete-dialog state and handler for managers acting on events.
// Components mix this in to get:
//   - data: deleteDialogOpen, deleteDialogEventId, deleteDialogError, deleting
//   - methods: openDeleteDialog(eventId), confirmDelete(), closeDeleteDialog()
//
// confirmDelete() resolves with { deleted: true } on 204 and
// { deleted: false, error } on 422 so the host component can react.
export default {
  data() {
    return {
      deleteDialogOpen: false,
      deleteDialogEventId: null,
      deleteDialogError: null,
      deleting: false,
    }
  },
  methods: {
    openDeleteDialog(eventId) {
      this.deleteDialogEventId = eventId
      this.deleteDialogError = null
      this.deleteDialogOpen = true
    },
    closeDeleteDialog() {
      this.deleteDialogOpen = false
      this.deleteDialogEventId = null
      this.deleteDialogError = null
    },
    confirmDelete() {
      if (!this.deleteDialogEventId) return Promise.resolve({ deleted: false })
      this.deleting = true
      return eventApi.destroy(this.deleteDialogEventId)
        .then(() => {
          this.deleting = false
          this.deleteDialogOpen = false
          return { deleted: true, eventId: this.deleteDialogEventId }
        })
        .catch((e) => {
          this.deleting = false
          const serverMessage = e && e.response && e.response.data && e.response.data.error
          this.deleteDialogError = serverMessage || "Couldn't delete this event."
          return { deleted: false, error: this.deleteDialogError }
        })
    },
  },
}
